var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "member-container full-height" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.formData.id ? "編輯資料" : "新增資料",
            visible: _vm.dialogFormVisible,
            top: "2%",
            width: "90%",
          },
          on: {
            closed: _vm.onDialogArticleClosed,
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.formLoading,
                  expression: "formLoading",
                },
              ],
              ref: "ArticleValidateForm",
              attrs: { model: _vm.formData },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: "封面照", "label-width": _vm.formLabelWidth },
                },
                [
                  _c(
                    "div",
                    [
                      _c("Upload", {
                        ref: "uploadArticleRef",
                        attrs: {
                          accept: ".jpg,.jpeg,.png",
                          payload: _vm.formData,
                          "data-obj": _vm.fileObj,
                          limitText:
                            "圖片尺寸:840x480，須為.jpg,.jpeg,.png格式，限制不超過2000MB",
                          "limit-file-count": 3,
                          "use-drag": false,
                          action: "ToursCombine/saveArticle",
                          "auto-upload": false,
                          "show-file-list": true,
                          "form-on-loading-parent": _vm.formLoading,
                          "btn-txt": "上傳",
                          "before-file-list":
                            _vm.formData.fileInfo &&
                            _vm.formData.fileInfo.length
                              ? _vm.formData.fileInfo[0].files
                              : [],
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "影片連結",
                    "label-width": _vm.formLabelWidth,
                    prop: "externalLink",
                    rules: [{ validator: _vm.validateLink, trigger: "blur" }],
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      placeholder: "若有輸入影片連結，則封面會以影片優先顯示",
                    },
                    model: {
                      value: _vm.formData.externalLink,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "externalLink", $$v)
                      },
                      expression: "formData.externalLink",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "標題",
                    "label-width": _vm.formLabelWidth,
                    prop: "title",
                    rules: [
                      {
                        required: true,
                        message: "請輸入標題",
                        trigger: "blur",
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      maxlength: "100",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.formData.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "title", $$v)
                      },
                      expression: "formData.title",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "國家",
                    "label-width": _vm.formLabelWidth,
                    prop: "country",
                    rules: [
                      { type: "array", message: "型別錯誤", trigger: "blur" },
                      {
                        required: true,
                        message: "請選擇國家",
                        trigger: "blur",
                      },
                    ],
                  },
                },
                [
                  _c("el-cascader", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      options: _vm.cascaderCountryOptions,
                      props: {
                        multiple: true,
                        value: "id",
                      },
                      "collapse-tags": "",
                    },
                    model: {
                      value: _vm.formData.country,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "country", $$v)
                      },
                      expression: "formData.country",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "項目及分類",
                    "label-width": _vm.formLabelWidth,
                    prop: "itemType",
                    rules: [
                      { type: "array", message: "型別錯誤", trigger: "blur" },
                      {
                        required: true,
                        message: "請選擇項目及分類",
                        trigger: "blur",
                      },
                    ],
                  },
                },
                [
                  _c("el-cascader", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      options: _vm.cascaderOptions,
                      props: {
                        multiple: true,
                        value: "id",
                        label: "title",
                        children: "types",
                      },
                      "collapse-tags": "",
                    },
                    model: {
                      value: _vm.formData.itemType,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "itemType", $$v)
                      },
                      expression: "formData.itemType",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "內容",
                    "label-width": _vm.formLabelWidth,
                    prop: "articleContent",
                  },
                },
                [
                  _c(
                    "div",
                    [
                      _c("tinymce", {
                        ref: "tinymce",
                        attrs: { height: 300, type: 16 },
                        model: {
                          value: _vm.formData.articleContent,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "articleContent", $$v)
                          },
                          expression: "formData.articleContent",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "發文者",
                    "label-width": _vm.formLabelWidth,
                    prop: "BuildUserID",
                    rules: [
                      {
                        required: true,
                        message: "請輸入標題",
                        trigger: "blur",
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "請選擇作者" },
                      model: {
                        value: _vm.formData.BuildUserID,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "BuildUserID", $$v)
                        },
                        expression: "formData.BuildUserID",
                      },
                    },
                    _vm._l(_vm.authorList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.authorName, value: item.bindUser },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "發文日期",
                    "label-width": _vm.formLabelWidth,
                    prop: "buildDate",
                    rules: [
                      {
                        required: true,
                        message: "請選擇發文日期",
                        trigger: "blur",
                      },
                    ],
                  },
                },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "datetime",
                      placeholder: "請選擇發文日期",
                      format: "yyyy-MM-dd HH:mm:ss",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                    },
                    model: {
                      value: _vm.formData.buildDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "buildDate", $$v)
                      },
                      expression: "formData.buildDate",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "hashTags",
                    "label-width": _vm.formLabelWidth,
                    prop: "hashtags",
                    rules: [
                      { type: "array", message: "型別錯誤", trigger: "blur" },
                    ],
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        multiple: "",
                        filterable: "",
                        remote: "",
                        "reserve-keyword": "",
                        "allow-create": "",
                        placeholder: "請輸入關鍵字",
                        "remote-method": _vm.remoteMethod,
                        loading: _vm.loading,
                        "no-data-text": "無資料",
                        "value-key": "id",
                      },
                      model: {
                        value: _vm.formData.hashtags,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "hashtags", $$v)
                        },
                        expression: "formData.hashtags",
                      },
                    },
                    _vm._l(_vm.options, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.title, value: item },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "排序",
                    "label-width": _vm.formLabelWidth,
                    prop: "sort",
                    rules: [
                      {
                        required: true,
                        message: "請輸入排序",
                        trigger: "blur",
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { autocomplete: "off" },
                    model: {
                      value: _vm.formData.sort,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "sort", $$v)
                      },
                      expression: "formData.sort",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.onDialogArticleClosed } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.saveData("ArticleValidateForm")
                    },
                  },
                },
                [_vm._v("儲 存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          attrs: {
            top: _vm.dialogTopMargin,
            visible: _vm.dialogIntroFormVisible,
            title: _vm.roleSettingObj.id ? "編輯簡介" : "新增簡介",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogIntroFormVisible = $event
            },
            closed: _vm.onDialogClosed,
          },
        },
        [
          _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("el-alert", {
                    attrs: {
                      closable: false,
                      title: "此為向外公開的個人簡介資料",
                      type: "warning",
                      effect: "dark",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form",
                {
                  ref: "introductionForm",
                  attrs: {
                    rules: _vm.introRules,
                    size: "mini",
                    model: _vm.roleSettingObj,
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "頭貼",
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c(
                        "div",
                        [
                          _c("span", [_vm._v("尺寸:70*70")]),
                          _c("Upload", {
                            ref: "uploadRef",
                            attrs: {
                              accept: ".jpg,.jpeg,.png",
                              payload: _vm.roleSettingObj,
                              "limit-file-count": 1,
                              "data-obj": _vm.fileObj,
                              "use-drag": false,
                              action: "ToursCombine/saveIntroAvatar",
                              "auto-upload": false,
                              "show-file-list": true,
                              "form-on-loading-parent": _vm.listLoading,
                              "btn-txt": "上傳",
                              "before-file-list":
                                _vm.roleSettingObj.fileInfo &&
                                _vm.roleSettingObj.fileInfo.length
                                  ? _vm.roleSettingObj.fileInfo[0].files
                                  : [],
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "名稱", prop: "authorName" } },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "50" },
                        model: {
                          value: _vm.roleSettingObj.authorName,
                          callback: function ($$v) {
                            _vm.$set(_vm.roleSettingObj, "authorName", $$v)
                          },
                          expression: "roleSettingObj.authorName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "簡介", prop: "introduction" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          autosize: { minRows: 4, maxRows: 4 },
                        },
                        model: {
                          value: _vm.roleSettingObj.introduction,
                          callback: function ($$v) {
                            _vm.$set(_vm.roleSettingObj, "introduction", $$v)
                          },
                          expression: "roleSettingObj.introduction",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "排序", prop: "sort" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.roleSettingObj.sort,
                          callback: function ($$v) {
                            _vm.$set(_vm.roleSettingObj, "sort", $$v)
                          },
                          expression: "roleSettingObj.sort",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._l(
                    _vm.roleSettingObj.socialLinkList,
                    function (social, index) {
                      return _c(
                        "el-form-item",
                        { key: index, attrs: { label: "社群" + index } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "請選擇" },
                              model: {
                                value: social.socialType,
                                callback: function ($$v) {
                                  _vm.$set(social, "socialType", $$v)
                                },
                                expression: "social.socialType",
                              },
                            },
                            _vm._l(_vm.socialLinkSelectList, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                          _c("el-input", {
                            staticStyle: { width: "50%" },
                            model: {
                              value: social.url,
                              callback: function ($$v) {
                                _vm.$set(social, "url", $$v)
                              },
                              expression: "social.url",
                            },
                          }),
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.removeSocialLink(social)
                                },
                              },
                            },
                            [_vm._v("删除")]
                          ),
                        ],
                        1
                      )
                    }
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("el-button", { on: { click: _vm.addSocialLink } }, [
                        _vm._v("新增社群"),
                      ]),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.saveIntroduction("introductionForm")
                    },
                  },
                },
                [_vm._v("確定")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: { click: _vm.onDialogClosed },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          attrs: {
            visible: _vm.dialogPictureFormVisible,
            title: "編輯證照",
            top: "2%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogPictureFormVisible = $event
            },
            closed: _vm.onPictureDialogClosed,
          },
        },
        [
          _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c(
                "el-form",
                { attrs: { model: _vm.pictureData } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "證照",
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c(
                        "div",
                        [
                          _c("span", [_vm._v("尺寸:840*480")]),
                          _c("Upload", {
                            ref: "uploadLRef",
                            attrs: {
                              accept: ".jpg,.jpeg,.png",
                              payload: _vm.pictureData,
                              "data-obj": _vm.fileObj,
                              "limit-file-count": 5,
                              "use-drag": false,
                              action: "ToursCombine/saveLeaderProfile",
                              "auto-upload": false,
                              "show-file-list": true,
                              "form-on-loading-parent": _vm.listLoading,
                              "btn-txt": "上傳",
                              "before-file-list":
                                _vm.pictureData && _vm.pictureData.length
                                  ? _vm.pictureData[0].files
                                  : [],
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm.pictureData && _vm.pictureData.length
                ? [
                    _vm._l(_vm.pictureData[0].files, function (item, index) {
                      return [
                        _c("span", { key: index }, [
                          _vm._v(_vm._s(item.fileName)),
                        ]),
                        _c("img", {
                          key: index,
                          staticStyle: {
                            "margin-top": "10px",
                            "margin-bottom": "20px",
                          },
                          attrs: { width: "100%", src: item.url, alt: "" },
                        }),
                      ]
                    }),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.savePicture } },
                [_vm._v("確定")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: { click: _vm.onPictureDialogClosed },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "full-height",
          staticStyle: { padding: "20px", "padding-bottom": "0" },
        },
        [
          _c(
            "div",
            { staticStyle: { "padding-bottom": "0" } },
            [
              _c(
                "el-form",
                {
                  attrs: { inline: true },
                  nativeOn: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "搜尋" } },
                    [
                      _c("el-input", {
                        attrs: { size: "mini", placeholder: "輸入查詢名稱" },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleFilter($event)
                          },
                        },
                        model: {
                          value: _vm.listQuery.qry,
                          callback: function ($$v) {
                            _vm.$set(_vm.listQuery, "qry", $$v)
                          },
                          expression: "listQuery.qry",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "filter-item",
                          attrs: {
                            size: "mini",
                            type: "primary",
                            icon: "el-icon-search",
                          },
                          on: { click: _vm.handleFilter },
                        },
                        [_vm._v(" 搜尋 ")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "success", size: "mini" },
                          on: { click: _vm.addData },
                        },
                        [_vm._v("建立文章")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { position: "relative", height: "80%" } },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading",
                    },
                  ],
                  key: _vm.tableKey,
                  attrs: {
                    size: "mini",
                    data: _vm.list,
                    border: "",
                    fit: "",
                    "highlight-current-row": "",
                    height: "100%",
                  },
                  on: { "sort-change": _vm.sortChange },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "ID",
                      prop: "id",
                      sortable: "custom",
                      align: "center",
                      width: "80",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [_c("span", [_vm._v(_vm._s(row.id))])]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "頭貼", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-image", {
                              staticStyle: { height: "50px" },
                              attrs: {
                                src:
                                  scope.row.fileInfo.length > 0
                                    ? scope.row.fileInfo[0].files[0].url
                                    : "https://fakeimg.pl/70/",
                                fit: "contain",
                                "preview-src-list":
                                  scope.row.fileInfo.length > 0
                                    ? [scope.row.fileInfo[0].files[0].url]
                                    : ["https://fakeimg.pl/70/"],
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "帳號",
                      prop: "account",
                      sortable: "custom",
                      align: "left",
                      width: "130",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [_c("span", [_vm._v(_vm._s(row.account))])]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "角色",
                      prop: "roles",
                      sortable: "custom",
                      align: "center",
                      width: "130",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("span", [_vm._v(_vm._s(row.roles.toString()))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "名稱",
                      prop: "authorName",
                      sortable: "custom",
                      align: "left",
                      width: "130",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.openUrl + "/" + row.code,
                                  target: "_blank",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: { color: "rgb(64, 158, 255)" },
                                  },
                                  [_vm._v(_vm._s(row.authorName))]
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "簡介",
                      prop: "introduction",
                      sortable: "custom",
                      align: "center",
                      width: "200",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("span", [_vm._v(_vm._s(row.introduction))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "排序",
                      prop: "sort",
                      sortable: "custom",
                      align: "center",
                      width: "130",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [_c("span", [_vm._v(_vm._s(row.sort))])]
                        },
                      },
                    ]),
                  }),
                  _vm.title == "TCLeader"
                    ? _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "資格審核",
                          width: "150",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.manuallyValidated == false
                                    ? _c("i", {
                                        staticClass: "el-icon-circle-close",
                                        staticStyle: {
                                          "font-size": "28px",
                                          color: "red",
                                        },
                                      })
                                    : _c("i", {
                                        staticClass: "el-icon-circle-check",
                                        staticStyle: { "font-size": "28px" },
                                      }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1752101092
                        ),
                      })
                    : _vm._e(),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "操作", width: "200" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                staticClass: "filter-item",
                                attrs: {
                                  size: "mini",
                                  type: "primary",
                                  icon: "el-icon-edit",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.editIntroductionInfo(scope.row)
                                  },
                                },
                              },
                              [_vm._v(" 編輯簡介 ")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm.title == "TCLeader"
                    ? _c("el-table-column", {
                        attrs: { align: "center", label: "操作", width: "200" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "filter-item",
                                      attrs: {
                                        size: "mini",
                                        type: "success",
                                        icon: "el-icon-edit",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.viewPicture(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v(" 編輯證照 ")]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1498927596
                        ),
                      })
                    : _vm._e(),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "刪除", width: "200" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                staticClass: "filter-item",
                                attrs: {
                                  size: "mini",
                                  type: "danger",
                                  icon: "el-icon-delete",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteIntro(scope.row)
                                  },
                                },
                              },
                              [_vm._v(" 刪除 ")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total > 0",
              },
            ],
            staticStyle: { "padding-top": "0" },
            attrs: {
              total: _vm.total,
              page: _vm.listQuery.page,
              limit: _vm.listQuery.limit,
            },
            on: {
              "update:page": function ($event) {
                return _vm.$set(_vm.listQuery, "page", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.listQuery, "limit", $event)
              },
              pagination: _vm.getList,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }